import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import Fuse from "fuse.js";

import User from "pages/Users/User";
import Heading from "components/Elements/Heading";

const keys = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
};

const { FIRST_NAME, LAST_NAME } = keys;

const fuseOptions = {
  shouldSort: true,
  threshold: 0.4,
  location: 0,
  distance: 50,
  maxPatternLength: 12,
  minMatchCharLength: 3,
  keys: [FIRST_NAME, LAST_NAME],
};

const Users = (props) => {
  const [query, setQueryState] = useState("");
  const [usersList] = useState(props.data);

  const renderUsers = () => {
    const fuse = new Fuse(usersList, fuseOptions);
    const data = query ? fuse.search(query) : usersList;

    if (data.length === 0) {
      return (
        <div className="col-12 d-flex flex-column align-items-center">
          <Heading size={5} className={"mt-5"}>
            No users found
          </Heading>
        </div>
      );
    } else {
      return data.map((user, i) => <User key={i} user={user} />);
    }
  };

  const handleSearch = (e) => {
    setQueryState(e.target.value);
  };

  const input_styles = clsx("form-control", "form-control-users-search");

  const users_count = props.data.length;
  return (
    <Fragment>
      <div className="mb-3 row">
        <div className="col-4">
          <form>
            <div className="ml-2 mr-2 form-group">
              <input
                placeholder={`Search ${users_count} Users`}
                onChange={(e) => handleSearch(e)}
                className={input_styles}
              />
            </div>
          </form>
        </div>
        <div className="pr-4 text-right col-8">
          <Link to="/settings/user/create" className="mb-3 btn btn-primary">
            <i className="fas fa-plus" /> New User
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="flex-wrap col-12 d-flex justify-content-left align-items-start">
          {renderUsers()}
        </div>
      </div>
    </Fragment>
  );
};

export default Users;
